import React from "react";

export const CloseIcon = (): JSX.Element => {
  return (
    <svg
      width={14}
      height={14}
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <path
        d="M13.292 2.118a.997.997 0 00.003-1.413.999.999 0 00-1.413.003L7 5.59 2.118.708A.997.997 0 00.705.705a.999.999 0 00.003 1.413L5.59 7 .708 11.882a.997.997 0 00-.003 1.413.999.999 0 001.413-.003L7 8.41l4.882 4.882a.997.997 0 001.413.003.999.999 0 00-.003-1.413L8.41 7l4.882-4.882z"
        fill="#9D9C9F"
        fillRule="evenodd"
      />
    </svg>
  );
};
